var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMuseum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    id: "svg6584",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6586"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-952.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 50,964.86202 -27.083334,20.83332 54.166667,0 z m -22.916667,24.99995 c -2.308375,0 -3.840208,1.8817 -4.166667,4.1667 l 0,29.16673 -7.291666,12.5 c -0.618042,1.0596 -1.041667,1.4862 -1.041667,2.0833 0,2.0833 2.631875,2.0833 4.166667,2.0833 l 62.5,0 c 1.479125,0 4.166667,0 4.166667,-2.0833 0,-0.6092 -0.360833,-0.9162 -1.041667,-2.0833 l -7.291667,-12.5 0,-29.16672 c 0,-2.30831 -1.858291,-4.1667 -4.166666,-4.1667 z m 8.333333,8.3334 c 2.083334,0 4.166667,0 6.250001,0 2.083333,0 4.166666,4.16663 4.166666,4.16663 L 50,1012.7787 54.166667,1002.362 c 0.929916,-2.325 2.083333,-4.16663 4.166666,-4.16663 2.083334,0 4.166667,0 6.25,0 2.308334,0 4.166667,1.85833 4.166667,4.16663 l 0,20.8334 c 0,2.0833 -2.083333,4.1666 -4.166667,4.1666 -2.083333,0 -4.166666,-2.0833 -4.166666,-4.1666 l 0,-16.6667 -6.25,12.5 c 0,0 -2.083334,4.1667 -4.166667,4.1667 -2.083333,0 -4.166667,-4.1667 -4.166667,-4.1667 l -6.25,-12.5 0,16.6667 c 0,2.0833 -2.083333,4.1666 -4.166667,4.1666 -2.083333,0 -4.166666,-2.0833 -4.166666,-4.1666 l 0,-4.1667 0,-16.6667 c 0,-2.3083 1.858333,-4.16662 4.166666,-4.16662 z",
    id: "rect7645-6-5-0",
    style: {
      color: "#000000",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      marker: "none",
      visibility: "visible",
      display: "inline",
      overflow: "visible",
      enableBackground: "accumulate"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuseum);
export default __webpack_public_path__ + "static/media/museum.8c72569e6b1c4bc98ca1ef7af0ae3f93.svg";
export { ForwardRef as ReactComponent };